<mobi-breadcrumb />
<mobi-hero-text [title]="entity().title" />
<div class="page-content mobi-ui-margin-t-md">
  <mobi-content-section width="sm" [content]="content">
    <ng-template #content>
      <mobi-view
        [viewId]="entity().viewRef?.view?.id || 'pr'"
        [display]="entity().viewRef?.view?.display || 'default'"
        [rowFormatter]="groupRowsByYearAndMonth"
        [title]="entity().title"
        [results]="result"
      >
        <ng-template #result let-rows="rows">
          @if (rows() && rows().length > 0) {
            <div aria-live="polite">
              @for (year of rows(); track year.year) {
                <div class="mobi-ui-margin-t-xl !mb-0 no-heading-spacing">
                  <div
                    class="mobi-ui-grid mobi-ui-text-inked mobi-ui-font-h2 view-enter-animation mobi-ui-margin-y-md"
                  >
                    <h2
                      class="view-enter-animation block mobi-ui-col-1/1 md:mobi-ui-col-1/4 md:text-right py-0"
                    >
                      {{ year.year }}
                    </h2>
                  </div>
                  @for (month of year.months; track month.originalDate) {
                    <div class="mobi-ui-grid mobi-ui-margin-b-md">
                      <div
                        class="view-enter-animation mobi-ui-text-inked mobi-ui-font-h3 mobi-ui-margin-t-xxs mobi-ui-col-1/1 md:mobi-ui-col-1/4 md:text-right"
                      >
                        {{ month.originalDate | date: 'LLLL' : '' : locale() }}
                      </div>
                      <ol
                        class="mobi-ui-col-1/1 md:mobi-ui-col-3/4 list-none mobi-ui-padding-t-xxs"
                      >
                        @for (item of month.rows; track item.path.alias) {
                          <li>
                            <a
                              class="mobi-ui-padding-y-sm border-t border-border hover:border-border flex flex-col view-enter-animation"
                              [betterRouterLink]="item.path.alias"
                            >
                              <span
                                class="mobi-ui-text-inked mobi-ui-font-h5 mobi-ui-font-size-150 !pb-0"
                              >
                                {{ item.field_cm_teaser_title }}
                              </span>
                              <span class="mobi-ui-font-size-150 text-common-text">
                                {{
                                  item.field_pr_date
                                    | date: 'EEEE, dd. LLLL yyyy' : '' : locale()
                                }}
                              </span>
                            </a>
                          </li>
                        }
                      </ol>
                    </div>
                  }
                </div>
              }
            </div>
          }
        </ng-template>
      </mobi-view>
    </ng-template>
  </mobi-content-section>
  <div class="content-section is-background">
    <div>
      <mobi-concierge />
    </div>
  </div>
</div>
